<dialog-template
  [dialogId]="dialogId"
  [header]="dialogTitle"
  [primaryBtnDisabled]="name === ''"
  (primaryBtnClicked)="save($event)"
>
  <ng-template #contentTemplate>
    <div class="tw-flex tw-items-center tw-mb-4">
      <label
        for="template-name"
        class="tw-font-semibold tw-mr-4 tw-text-left tw-w-40"
      >
        Template name
      </label>
      <input
        pInputText
        [(ngModel)]="name"
        id="template-name"
        class="tw-w-full"
      />
    </div>

    <div
      *ngIf="invalidNameError"
      class="tw-w-full"
    >
      <p-message
        severity="error"
        styleClass="tw-w-full"
      >
        <div class="tw-text-left">
          <div class="tw-font-medium">A template name can only include certain characters</div>
          <p>The characters allowed in a template name are: a-z, A-Z, 0-9, _, -, . and spaces</p>
        </div>
      </p-message>
    </div>

    <div *ngIf="isDashboardApp">
      <div class="tw-flex tw-items-center">
        <label
          for="template-description"
          class="tw-font-semibold tw-mr-4 tw-text-left tw-w-40"
        >
          Description
        </label>
        <input
          pInputText
          [(ngModel)]="description"
          id="template-description"
          class="tw-w-full"
        />
      </div>
    </div>

    <div
      *ngIf="burtAdmin && isDashboardApp"
      class="tw-flex tw-justify-end tw-items-center tw-gap-2 tw-mt-4 tw-mb-6"
    >
      <p-checkbox
        [(ngModel)]="global"
        inputId="template-global"
        name="template-global"
        [binary]="true"
      ></p-checkbox>
      <label for="template-global">Global</label>
    </div>
  </ng-template>
</dialog-template>
